module.exports = __webpack_public_path__ + "img/logo-large.9b46a752.svg";